import { convertSchoolNamesToAbbreviations, createEllipses } from '../../utilityFunctions';
import './admin-applications-card.css'
const AdminApplicationsCard = ({toggleApplication, application, isApp, setOpen, setOpenWorkflowModal2024}) => {
    if(isApp) {
        let name = `${application.key1app[0] + '.' + ' ' + application.key2app}`
        return (
            <div className='admin-applications__card' onClick={() => toggleApplication(application)}>
                <div className='admin-applications__card__name'>{createEllipses(name, 10)}</div>
                <div className='admin-applications__card__tag-wrapper'>
                    <div className='student-onboarding-task-card-2023__school'>{convertSchoolNamesToAbbreviations(application.key14app).toUpperCase()}</div>
                    {application.key13app.length > 1 ?
                        <div className='admin-applications__card__extra-inst-wrapper'>
                            <div className='student-onboarding-task-card-2023__school'>{createEllipses(application.key13app[0].parentInstrument, 5)}</div>
                            <div className='student-onboarding-task-card-2023__school'>+ {(application.key13app.length + 1) - 1}</div>
                        </div>
                    : 
                        <div className='student-onboarding-task-card-2023__school'>{application.key13app[0]?.parentInstrument}</div>
                    }
                </div>
            </div>
        )
    } else {
        return (
            <div className='admin-applications__card' onClick={() => setOpenWorkflowModal2024(application)}>
                <div className='admin-applications__card__name'>{createEllipses(application.todoName, 10)}</div>
                <div className='admin-applications__card__tag-wrapper'>
                    <div className='student-onboarding-task-card-2023__school'>{application.whichSchool?.toUpperCase()}</div>
                    {application.instrumentList.length > 0 && 
                    <div>
                    {
                        application.instrumentList.length > 1 ?
                        <div className='student-onboarding-task-card-2023__school'>{application.instrumentList.length > 0 && application.instrumentList[0].parentInstrument}</div>
                        : 
                        <div className='admin-applications__card__extra-inst-wrapper'>
                            <div className='student-onboarding-task-card-2023__school'>{application.instrumentList.length > 0 && application.instrumentList[0].parentInstrument}</div>
                            <div className='student-onboarding-task-card-2023__school'>+ {(application.instrumentList.length + 1) - 1}</div>
                        </div>
                    }
                    </div>}
                </div>
            </div>
        )
    }
}
export default AdminApplicationsCard;